module.exports = __webpack_public_path__ + "static/logo-2-ff0372755a6d8e178c00009bfa97b2cd.svg";